document.addEventListener('DOMContentLoaded', function () {
    moveCookieBannerToTop();
    wcagCookieBanner();
    initFocusTrapForCookieBanner();
});
function wcagCookieBanner() {
    setTextForCategoryCheckboxes();
    addAriaHiddenToAllSvgElements();
    removeAriaHiddenFromCookieBanner();
}

function removeAriaHiddenFromCookieBanner() {
    const target = document.querySelector('#s-cnt');

    target.removeAttribute('aria-hidden');

    const originalSetAttribute = target.setAttribute;
    target.setAttribute = function (name, value) {
        const currentValue = this.getAttribute(name);

        if (currentValue == value) return;
        if (name == 'aria-hidden') return;

        originalSetAttribute.call(this, name, value);
    };
}

function addAriaHiddenToAllSvgElements() {
    document.querySelectorAll('#s-inr svg').forEach(function (svg) {
        svg.setAttribute('aria-hidden', 'true');
    });
}

function setTextForCategoryCheckboxes() {
    const categoryCheckboxes = document.querySelectorAll('.titlecategory.b-bn');
    categoryCheckboxes.forEach(function (categoryCheckbox) {
        const categoryCheckboxLabel = categoryCheckbox.querySelector('.expand-button-cfwrapper .sr-only');
        // get text of button with class b-tl
        const categoryButton = categoryCheckbox.querySelector('.b-tl');
        categoryCheckboxLabel.textContent = categoryButton.textContent;
    });
}


function moveCookieBannerToTop() {
    const cookieBanner = document.getElementById('cc--main');
    if (cookieBanner) {
        cookieBanner.classList.add('d-none');
        document.body.insertBefore(cookieBanner, document.body.firstChild);
        cookieBanner.classList.remove('d-none');
    }
}

function initFocusTrapForCookieBanner() {

    // wait 1 second for cookie banner to be rendered
    setTimeout(function () {
        const cookieBannerFocusTrap = setFocusTrapForCookieBanner();

        addFocusTrapOnInit(cookieBannerFocusTrap);

    }, 1000);

}

function addFocusTrapOnInit(cookieBannerFocusTrap) {

    // check if cookie banner is visible
    if (document.querySelector('html').classList.contains('show--settings')) {
        cookieBannerFocusTrap.activate();
    }
}

function setFocusTrapForCookieBanner() {

    // create focus trap
    const cookieBannerFocusTrap = focusTrap.createFocusTrap('#cc--main');

    // remove focus trap on click of multiple close buttons
    document.querySelectorAll('.c-bn').forEach(function (button) {
        button.addEventListener('mousedown', cookieBannerFocusTrap.deactivate);
    });

    return cookieBannerFocusTrap;


}